import React from 'react';
export function Header() {
  return <div className="bg-bg0 border-b-[3px] border-gold-d pt-4 px-4 pb-4 md:pt-6 md:px-9 md:pb-5 relative overflow-hidden" data-id="element-28">
      <div className="absolute inset-0 pointer-events-none bg-header-pattern" data-id="element-29"></div>
      <div className="relative max-w-[1250px] mx-auto flex flex-col gap-2 md:flex-row md:items-end md:justify-between md:gap-4" data-id="element-30">
        <div className="min-w-0" data-id="element-31">
          <h1 className="font-serif text-[1.4rem] md:text-[2.2rem] font-bold text-gold-d tracking-[0.02em] leading-[1.2]" data-id="element-32">
            Ultimate Balance Method & Matrix
          </h1>
          <p className="text-[0.8rem] md:text-[0.95rem] text-[#a0aec0] italic mt-1 md:mt-1.5" data-id="element-33">
            Dr. Richard Tan's Global Balance, Magic Points, Pattern Protocols &
            Master Tung
          </p>
        </div>
        <div className="text-[0.7rem] font-extrabold tracking-[0.1em] uppercase bg-teal text-white py-1.5 px-3.5 rounded-xl whitespace-nowrap self-start mt-0 md:mt-1 shadow-teal-badge" data-id="element-34">
          Comprehensive Edition
        </div>
      </div>
    </div>;
}